import { freezeRequest } from './generation-request.js';
import { isImageDeliveryUnverified } from './image-delivery-status.js';

function detach(value) {
  if (Array.isArray(value)) return value.map(detach);
  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, detach(item)]));
  }
  return value;
}

export function restoredGenerationStatus(request, results) {
  const terminal = new Set(['done', 'completed', 'error', 'failed', 'canceled', 'cancelled']);
  const active = Object.values(results).some((result) => result.unverified ||
    (result.projectId && !terminal.has(result.status)));
  const unfinished = request.slots.some((slot) => !terminal.has(results[slot.id]?.status));
  const failed = Object.values(results).some((result) => ['error', 'failed', 'canceled', 'cancelled'].includes(result.status));
  return active ? 'recovering' : unfinished ? 'paused' : failed ? 'error' : 'completed';
}

/** Restore inputs and outcomes; a saved record never grants spending approval. */
export function restoredGenerationRun(snapshot) {
  if (!snapshot?.request) return { request: null, attemptId: null, attemptSlotIds: [], quote: null, queue: null, status: 'idle', results: {} };
  const request = freezeRequest(snapshot.request);
  const results = detach(snapshot.results || {});
  const attempted = snapshot.attemptId ? new Set(snapshot.attemptSlotIds || request.slots.map((slot) => slot.id)) : new Set();
  for (const slot of request.slots) {
    const result = results[slot.id];
    if (attempted.has(slot.id) && (!result || (['unsubmitted', 'submitting'].includes(result.status) && !result.projectId))) {
      results[slot.id] = { ...result, slotId: slot.id, status: 'unverified', unverified: true,
        errorCode: 'SUBMISSION_UNVERIFIED', error: 'This submission may still be running. Check your account creations before retrying.' };
    } else if (result && (result.errorCode === 'RESULT_UNAVAILABLE' ||
      isImageDeliveryUnverified({ ...result, details: result.errorDetails || result.errorData }, result.projectId))) {
      results[slot.id] = { ...result, status: 'unverified', unverified: true };
    }
  }
  return { request, results, attemptId: null, attemptSlotIds: [], quote: null, queue: null,
    status: restoredGenerationStatus(request, results) };
}
